function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n                                                            .st14{fill:#231F20;}\r\n                                                        ");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M70,70.4c-0.6,0-1.1-0.2-1.5-0.6c-0.4-0.4-0.6-0.9-0.6-1.5c0-0.6,0.2-1.1,0.6-1.5l15.1-14.7H34.2                                                                         c-1.2,0-2.1-1-2.1-2.1c0-1.2,1-2.1,2.1-2.1h49.3L68.5,33.2c-0.4-0.4-0.6-0.9-0.6-1.5c0-0.6,0.2-1.1,0.6-1.5                                                                         c0.4-0.4,0.9-0.6,1.5-0.6c0.6,0,1.1,0.2,1.5,0.6l18.6,18.1l0,0.1l0.2,0.1c0.1,0.1,0.1,0.1,0.2,0.2c0,0.1,0.1,0.1,0.1,0.2                                                                         c0.1,0.2,0.2,0.4,0.3,0.7c0,0.1,0,0.3,0,0.4c0,0.1,0,0.3,0,0.4c0,0.2-0.1,0.5-0.3,0.7c0,0-0.1,0.1-0.1,0.1                                                                         c-0.1,0.1-0.1,0.2-0.2,0.2l-0.1,0.1l0,0.1L71.5,69.8C71.1,70.2,70.6,70.4,70,70.4z"
}))));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M50,100C22.4,100,0,77.6,0,50c0-13.3,5.2-25.9,14.7-35.3C24.1,5.2,36.7,0,50,0c0,0,0,0,0,0                                                             c14.4,0,28.1,6.2,37.7,17.1c0.6,0.7,0.6,1.8-0.2,2.4c-0.7,0.6-1.8,0.6-2.4-0.2c-8.9-10.1-21.6-16-35-16c-12.4,0-24.1,4.8-32.9,13.6                                                             C8.3,25.9,3.5,37.6,3.5,50c0,25.7,20.9,46.5,46.5,46.5c13.5,0,26.4-5.9,35.3-16.2c0.6-0.7,1.7-0.8,2.4-0.2c0.7,0.6,0.8,1.7,0.2,2.4                                                             C78.4,93.7,64.5,100,50,100z"
});

var SvgLogout = function SvgLogout(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "logout",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogout, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logout.44bb4367.svg";
export { ForwardRef as ReactComponent };